import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { m as l } from "./tss-DN0acMKN.mjs";
import { I as m } from "./icon-v2-DGtVEk7e.mjs";
const d = l()((e, t) => {
  const { borderRadiuses: a, constructs: r } = e, { height: n, size: o, variant: i } = t;
  return {
    root: {
      alignItems: "center",
      backgroundColor: ((s) => {
        const u = {
          light: r.surface.neutral.forcedWhite,
          muted: r.surface.neutral.xWeak,
          primary: r.surface.primary.strong,
          secondary: r.surface.neutral.xWeak
        };
        return s ? u[s] : r.surface.neutral.xWeak;
      })(i),
      borderRadius: a[300],
      display: "flex",
      flexShrink: "0",
      height: n || o,
      minHeight: n ? o : void 0,
      justifyContent: "center",
      width: o
    }
  };
}), g = function(e) {
  return {
    40: 16,
    44: 20,
    48: 24,
    56: 24,
    64: 32
  }[e];
}, f = function(e) {
  return e ? {
    light: "primary-strong",
    muted: "neutral-weak",
    primary: "neutral-forced-white",
    secondary: "neutral-extra-strong"
  }[e] : "primary-strong";
};
function k(e) {
  const { icon: t, id: a, size: r, variant: n } = e, { classes: o } = d(e);
  return /* @__PURE__ */ c.jsx("div", { className: o.root, "data-fabric-component": "IconTile", id: a, children: t && typeof t == "string" ? /* @__PURE__ */ c.jsx(m, { color: f(n), name: t, size: g(r) }) : t });
}
export {
  k as I,
  g
};
//# sourceMappingURL=icon-tile-BJ1ib0c2.mjs.map
